import { useWorkspaceContext } from "../workspace-provider.js";
/**
 * Access the current workspace populated by `<WorkspaceProvider>`.
 *
 * @throws if called outside `<WorkspaceProvider>`.
 */
export function useWorkspace() {
    return useWorkspaceContext();
}
//# sourceMappingURL=use-workspace.js.map